'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @group Operations
 * @category Constructors
 */
const useOperation = key => {
  const constructor = input => {
    return {
      key,
      input
    };
  };
  constructor.key = key;
  return constructor;
};
const makeConfirmOptionsFinalizedOnMainnet = (metaplex, options) => {
  return metaplex.cluster === 'mainnet-beta' ? {
    ...options,
    commitment: 'finalized'
  } : options;
};

exports.makeConfirmOptionsFinalizedOnMainnet = makeConfirmOptionsFinalizedOnMainnet;
exports.useOperation = useOperation;
//# sourceMappingURL=Operation.cjs.map
